<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-12 col-lg-6 h-100 d-flex flex-column justify-content-center">
      <div>
        <!-- hero component -->
        <div class="brand mx-5 animate__animated animate__slideInUp">
          <h1 class="brand-logo">MERLIN</h1>
          <p class="brand-title">A magical developer tool.</p>

          <p class="brand-detail">A comprehensive solution to all the challenges faced by developers: generating code, writing unit tests, and documentation.</p>

          <div class="d-flex align-items-center my-4">
            <a class="main-link" routerLink="/code-fixes">
              Code Fixes</a>
            <a class="main-link mx-3" routerLink="/unit-test">Unit Tests</a>
          </div>
        </div>

        <!-- Main search component -->
        <div class="main-search mx-5 mt-5 animate__animated animate__slideInUp">
          <form (submit)="searchCode()">
            <div class="d-flex align-items-center">
              <mat-form-field appearance="outline" class="w-100">
                <input matInput placeholder="Ask anything related to code." [formControl]="queryText">
                <button matSuffix mat-icon-button aria-label="search" type="submit">
                  <span class="material-symbols-outlined">search</span>
                </button>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6 h-100 d-flex flex-column justify-content-center">
      <img src="assets/hero.gif" alt="hero image" height="100%">
    </div>
  </div>
</div>

<app-footer></app-footer>
